import React from 'react';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import { connect } from 'react-redux';
import AuthCheck from './containers/AuthContainer';
// import LandingRedirect from './components/LandingRedirect';

class Routes extends React.Component{
  render(){
    return(
      <Router>
        <div>
          <Route path="/" component={AuthCheck} />
        </div>
      </Router>
    );
  }
}

function mapStateToProps(state, props){
  return{
    // currentUrl: props.location.pathname,
    // jwt: state.auth.jwtToken,
    // redirectUrl: state.auth.redirectUrl
  };
}

export default connect(mapStateToProps)(Routes);



// WEBPACK FOOTER //
// ./src/routes.js